import { render, staticRenderFns } from "./purchase-org-tab.vue?vue&type=template&id=26ec62af"
import script from "./purchase-org-tab.vue?vue&type=script&lang=js"
export * from "./purchase-org-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports